import * as $ from 'jquery';

$(document).ready(function(){
    $(".scroll-bottom").click( () => {
        $('html,body').animate({scrollTop: $('.bottom-point').offset().top}, 400, 'swing');
    });

    $(".scroll-top").click( () => {
        $('html,body').animate({scrollTop: $('.top-point').offset().top}, 400, 'swing');
    });

    for(let anchor of ['webcam', 'weather', 'feed']) {
        if ($('#' + anchor + '-scroll').length){
            $('a[href="/#' + anchor + '"').on('click', function  (event) {
                event.preventDefault();
                $('.hamburger').click();
                $('html,body').animate({scrollTop: $('#' + anchor + '-scroll').offset().top}, 400, 'swing');
            });

            if (window.location.hash == '#' + anchor) {
                removeHash();
                $('html,body').animate({scrollTop: $('#' + anchor + '-scroll').offset().top}, 200, 'swing');
            }
        } 
    }
    
});

function removeHash () { 
    var scrollV, scrollH, loc = window.location;
    if ("pushState" in history)
        history.pushState("", document.title, loc.pathname + loc.search);
    else {
        // Prevent scrolling by storing the page's current scroll offset
        scrollV = document.body.scrollTop;
        scrollH = document.body.scrollLeft;

        loc.hash = "";

        // Restore the scroll offset, should be flicker free
        document.body.scrollTop = scrollV;
        document.body.scrollLeft = scrollH;
    }
}